export const PCP_SELECTION_INTRO_MODAL = { key: 'PCP_SELECTION_INTRO_MODAL', defaultValue: false };
export const FAMILY_ACTIVATION_INTRO_MODAL = { key: 'FAMILY_ACTIVATION_INTRO_MODAL', defaultValue: false };
export const SHOW_MEDICAL_TEAM_BANNER = { key: 'SHOW_MEDICAL_TEAM_BANNER', defaultValue: true };
